const KeyMirror = require("keymirror");

module.exports = KeyMirror({
    DIALOG_DOWNLOAD_OPEN: true,
    DIALOG_DOWNLOAD_CLOSE: true,
    DIALOG_TRANSACTION_OPEN: true,
    DIALOG_TRANSACTION_CLOSE: true,
    DIALOG_INCLUDED_OPEN: true,
    DIALOG_INCLUDED_CLOSE: true
});



// WEBPACK FOOTER //
// ./src/action-types/dialog.js